import styled from 'styled-components';
import { DatePicker, Input } from 'antd';

export const StyledDateInput = styled.div`
  height: 90px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  position: relative;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 20px;
  }

  .date-input-wrapper {
    display: flex;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(79, 79, 79, 0.5);
  }

  .date-input-wrapper-error {
    border-color: ${({ theme }) => theme.palette.coral};
  }

  .setur-picker {
    border: none;
    width: 100%;
    height: 100%;
  }

  .setur-picker-input > input {
    opacity: 0.5;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${({ theme }) => theme.palette.darkGray};
  }

  .setur-picker-focused {
    outline: none;
    box-shadow: none;
  }

  .setur-picker-suffix {
    display: none;
  }
  .date-input-title {
    margin-bottom: 3px;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #292a2c;
  }

  .date-input-label {
    opacity: 0.5;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${({ theme }) => theme.palette.darkGray};
  }

  .date-input-label-error {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${({ theme }) => theme.palette.coral};
  }
`;

export const StyledDateInputPicker = styled(DatePicker)``;
export const StyledInputPicker = styled(Input)``;

export const ChildDateAgeInput = styled.input`
  text-align: left;
  border: none;
  opacity: 1;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.matterHorn};
  padding: 0;
  text-transform: uppercase;

  &:focus {
    box-shadow: none;
    color: ${({ theme }) => theme.palette.matterHorn};
    opacity: 0.5;
    font-weight: normal;
  }
  &[type='date']::-webkit-calendar-picker-indicator,
  &[type='date']::-webkit-inner-spin-button {
    display: none;
  }
`;

export const DateInputContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-left: 15px;
`;

export const InputErrorBox = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
  padding: 3px;
`;

export const InputErrorText = styled.span`
  color: ${({ theme }) => theme.palette.coral};
`;
